<script>
  import { onDestroy } from 'svelte';
  import { getStores } from '$app/stores';
  import { browser } from '$app/environment';
  
  const { page } = getStores();
  const apiKey = $page.data.session.env.ONE_FLOW_API_KEY;
  const integrity = $page.data.session.env.ONE_FLOW_INTEGRITY;

  if (browser) {
    // eslint-disable-next-line no-underscore-dangle
    window._1flow = (e, d, v) => {
      setTimeout(() => {
        // eslint-disable-next-line no-underscore-dangle
        window._1flow(e, d, v || {});
      }, 500);
    };

    onDestroy(page.subscribe(async ({ data: { session: { user } } }) => {
      const organization = user?.organizations.sort()[0];
      const identification = {
        name: user?.name,
        role: user?.role,
        email: user?.email,
        organizationId: organization?.id,
        organizationName: organization?.name,
        commercebearEmployee: user?.email.endsWith('@commercebear.com'),
      };
      // eslint-disable-next-line no-underscore-dangle
      window._1flow('identify', user?.id, identification);
    }));
  }
</script>

<svelte:head>
  {#if browser}
    <script
      async
      data-api-key={apiKey}
      src='https://sdk.1flow.app/js/1flow.js'
      {integrity}
      crossorigin
    ></script>
  {/if}
</svelte:head>
